import mysql from "serverless-mysql"
import dotenv from "dotenv"

import log from "../log.js"

// needed to read the proper .env file, even when index.ts has it
dotenv.config()

const config = process.env.core_db_socket_path
	? {
			// socket path exists, production mode (linux)
			database: process.env.core_db_name,
			user: process.env.core_db_user,
			password: process.env.core_db_password,
			socketPath: process.env.core_db_socket_path,
		}
	: {
			// no socket path, development mode (windows)
			/* don't expose password or any sensitive info, done only for demo */
			host: "localhost",
			database: "core",
			user: "root",
			password: "",
			// connectionLimit: 50,
			port: 3306,
		}

const db = mysql({ config })

log(`Read database configuration as:
database: ${process.env.core_db_name}
user: ${process.env.core_db_user}
password: ${process.env.core_db_password}
password length: ${process.env.core_db_password?.length}
socketPath: ${process.env.core_db_socket_path}
`)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default async function executeQuery({ query, values = "" }: { query: string; values?: string }): Promise<any> {
	// log(`Executing query: ${query}`)
	// log(`Executing query: ${query} with values: ${values}`)
	// try {
	const results = await db.query(query, values)

	await db.end()

	return results
	// } catch (error) {
	// throw error;
	// }
}

// /etc/init.d
// /etc/systemd/system
